import { Product, CategoryInfo } from '../types';

export const CATEGORIES: CategoryInfo[] = [
  {
    id: 'mobilfunk',
    name: 'Mobilfunk',
    description: 'Finden Sie den passenden Mobilfunktarif mit SIM-Karten von Telekom, Vodafone, O2 und mehr.',
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg'
  },
  {
    id: 'smartphones',
    name: 'Smartphones',
    description: 'Entdecken Sie die neuesten Smartphones von Apple, Samsung und mehr - mit oder ohne Vertrag.',
    image: 'https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg'
  },
  {
    id: 'handytarif',
    name: 'Handytarife',
    description: 'Günstige Handytarife von allen deutschen Netzbetreibern - mit flexibler Laufzeit.',
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg'
  },
  {
    id: 'geraete',
    name: 'Geräte & Zubehör',
    description: 'Tablets, Smartwatches, Kopfhörer und mehr zu den besten Preisen.',
    image: 'https://images.pexels.com/photos/1474993/pexels-photo-1474993.jpeg'
  }
];

export const PRODUCTS: Product[] = [
  // Smartphones
  {
    id: 'iphone-16-pro-max',
    name: 'Apple iPhone 16 Pro Max',
    category: 'smartphones',
    price: 1449,
    oldPrice: 1599,
    monatlich: '65',
    anschlusshebühr: '39,99',
    description: 'Das iPhone 16 Pro Max mit 6,9 Zoll Super Retina XDR Display, A18 Pro Chip, 48MP Hauptkamera und 5G. Das leistungsstärkste iPhone für Profis und Technik-Liebhaber.',
    features: [
      '6,9" Super Retina XDR OLED Display',
      'A18 Pro Chip für maximale Leistung',
      '48MP Hauptkamera mit 5x Optischem Zoom',
      '5G & Wi-Fi 7',
      'Titanrahmen in 4 Farben',
      'Bis zu 33 Stunden Videowiedergabe',
    ],
    image: 'https://images.pexels.com/photos/699122/pexels-photo-699122.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: iPhone 16 Pro Max mit Unlimited Tarif' },
      { provider: 'vodafone', url: 'https://ndirect.ppro.de/click/iy4r', dealText: 'Vodafone Red+ Tarif' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'iphone-16-pro',
    name: 'Apple iPhone 16 Pro',
    category: 'smartphones',
    price: 1199,
    oldPrice: 1299,
    monatlich: '55',
    anschlusshebühr: '39,99',
    description: 'Das iPhone 16 Pro mit 6,3 Zoll Display, A18 Pro Chip und 48MP Kamera. Pro-Funktionen in kompakterem Format.',
    features: [
      '6,3" Super Retina XDR OLED Display',
      'A18 Pro Chip',
      '48MP Hauptkamera mit 5x Optischem Zoom',
      '5G & Wi-Fi 7',
      'Titanrahmen',
      'Action Button & Camera Control',
    ],
    image: 'https://images.pexels.com/photos/1294886/pexels-photo-1294886.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: iPhone 16 Pro' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'iphone-16',
    name: 'Apple iPhone 16',
    category: 'smartphones',
    price: 899,
    oldPrice: 999,
    monatlich: '40',
    anschlusshebühr: '39,99',
    description: 'Das iPhone 16 mit 6,1 Zoll Display, A18 Chip und 48MP Kamera. Das beste iPhone für den Alltag.',
    features: [
      '6,1" Super Retina XDR OLED Display',
      'A18 Chip',
      '48MP Hauptkamera mit 2x Optischem Zoom',
      '5G & Wi-Fi 6E',
      'Action Button & Camera Control',
      '6 Farben verfügbar',
    ],
    image: 'https://images.pexels.com/photos/1841841/pexels-photo-1841841.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: iPhone 16' },
      { provider: 'vodafone', url: 'https://ndirect.ppro.de/click/iy4r', dealText: 'Vodafone Red Tarif' },
    ],
    isNew: true,
  },
  {
    id: 'samsung-galaxy-s25-ultra',
    name: 'Samsung Galaxy S25 Ultra',
    category: 'smartphones',
    price: 1299,
    oldPrice: 1449,
    monatlich: '60',
    anschlusshebühr: '39,99',
    description: 'Das Samsung Galaxy S25 Ultra mit 6,9 Zoll Dynamic AMOLED 2X Display, 200MP Kamera und S-Pen. Das ultimative Android-Flaggschiff.',
    features: [
      '6,9" Dynamic AMOLED 2X 120Hz Display',
      'Snapdragon 8 Elite Prozessor',
      '200MP Hauptkamera mit 100x Zoom',
      'S-Pen integriert',
      'Titanrahmen',
      '5000 mAh Akku mit 45W Schnellladen',
    ],
    image: 'https://images.pexels.com/photos/1294886/pexels-photo-1294886.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Galaxy S25 Ultra' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'samsung-galaxy-s25',
    name: 'Samsung Galaxy S25',
    category: 'smartphones',
    price: 849,
    oldPrice: 949,
    monatlich: '40',
    anschlusshebühr: '39,99',
    description: 'Das Samsung Galaxy S25 mit 6,2 Zoll Display, 50MP Kamera und Snapdragon 8 Elite. Kompaktes Flaggschiff mit Top-Leistung.',
    features: [
      '6,2" Dynamic AMOLED 2X 120Hz Display',
      'Snapdragon 8 Elite Prozessor',
      '50MP Hauptkamera mit 3x Optischem Zoom',
      '5G & Wi-Fi 7',
      '4000 mAh Akku',
      'Kompaktes Design',
    ],
    image: 'https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Galaxy S25' },
    ],
    isNew: true,
  },
  {
    id: 'google-pixel-9-pro',
    name: 'Google Pixel 9 Pro',
    category: 'smartphones',
    price: 1099,
    oldPrice: 1199,
    monatlich: '50',
    anschlusshebühr: '39,99',
    description: 'Das Google Pixel 9 Pro mit 6,3 Zoll Display, Tensor G4 Chip und verbesserter KI-Kamera. Das beste Kamera-Smartphone von Google.',
    features: [
      '6,3" LTPO OLED 120Hz Display',
      'Google Tensor G4 Prozessor',
      '50MP Hauptkamera mit 5x Optischem Zoom',
      'Gemini Nano KI integriert',
      '7 Jahre Software-Updates',
      'IP68 wasserfest',
    ],
    image: 'https://images.pexels.com/photos/699122/pexels-photo-699122.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Pixel 9 Pro' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'samsung-galaxy-a55',
    name: 'Samsung Galaxy A55 5G',
    category: 'smartphones',
    price: 479,
    oldPrice: 549,
    monatlich: '25',
    anschlusshebühr: '29,99',
    description: 'Das Samsung Galaxy A55 5G mit 6,6 Zoll Display, 50MP Kamera und langlebigem Akku. Das beste Mittelklasse-Smartphone.',
    features: [
      '6,6" Super AMOLED 120Hz Display',
      'Exynos 1480 Prozessor',
      '50MP Hauptkamera mit OIS',
      '5000 mAh Akku',
      '5G unterstützt',
      'Gorilla Glass Victus+',
    ],
    image: 'https://images.pexels.com/photos/1841841/pexels-photo-1841841.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Galaxy A55' },
    ],
  },
  {
    id: 'xiaomi-redmi-note-13-pro',
    name: 'Xiaomi Redmi Note 13 Pro',
    category: 'smartphones',
    price: 299,
    oldPrice: 399,
    monatlich: '15',
    anschlusshebühr: '29,99',
    description: 'Das Xiaomi Redmi Note 13 Pro mit 200MP Kamera und AMOLED Display. Preis-Leistungs-Sieger in der Einsteigerklasse.',
    features: [
      '6,67" AMOLED 120Hz Display',
      'Snapdragon 7s Gen 2',
      '200MP Hauptkamera',
      '5100 mAh Akku mit 67W Schnellladen',
      '5G unterstützt',
      'IP54 staub- und wasserfest',
    ],
    image: 'https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Redmi Note 13 Pro' },
    ],
  },

  // Handytarife
  {
    id: 'vodafone-red-xl-5g',
    name: 'Vodafone Red XL 5G',
    category: 'handytarif',
    price: null,
    oldPrice: null,
    monatlich: '49,99',
    anschlusshebühr: '39,99',
    description: 'Vodafone Red XL mit unbegrenztem Datenvolumen, 5G und Allnet-Flat. Surfen ohne Limits im Vodafone D2-Netz.',
    features: [
      'Unlimited Datenvolumen mit 5G',
      'Allnet-Flat in alle dt. Netze',
      'SMS-Flatrate',
      'EU-Roaming inklusive',
      'Vodafone D2-Netz',
      '24 Monate Laufzeit',
    ],
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'vodafone', url: 'https://ndirect.ppro.de/click/iy4r', dealText: 'Jetzt Vodafone Red XL abschließen' },
    ],
    isFeatured: true,
  },
  {
    id: 'o2-o2-unlimited-m',
    name: 'O2 O2 Unlimited M',
    category: 'handytarif',
    price: null,
    oldPrice: null,
    monatlich: '34,99',
    anschlusshebühr: '29,99',
    description: 'O2 Unlimited M mit unbegrenztem Datenvolumen im O2-Netz. 5G inklusive und EU-Roaming.',
    features: [
      'Unlimited Datenvolumen mit 5G',
      'Allnet-Flat in alle dt. Netze',
      'SMS-Flatrate',
      'EU-Roaming inklusive',
      'O2/Telefónica Netz',
      'Monatlich kündbar möglich',
    ],
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'Jetzt O2 Unlimited M abschließen' },
    ],
    isFeatured: true,
  },
  {
    id: 'blau-allnet-paket-s',
    name: 'Blau Allnet Paket S',
    category: 'handytarif',
    price: null,
    oldPrice: null,
    monatlich: '9,99',
    anschlusshebühr: '9,99',
    description: 'Blau Allnet Paket S mit 3GB Datenvolumen im O2-Netz. Der günstigste Einstiegstarif mit Allnet-Flat.',
    features: [
      '3 GB Datenvolumen (LTE)',
      'Allnet-Flat in alle dt. Netze',
      'SMS-Flatrate',
      'O2/Telefónica Netz',
      'Monatlich kündbar',
      'Prepaid-Option verfügbar',
    ],
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'Jetzt Blau Allnet S abschließen' },
    ],
  },

  // Geräte & Zubehör
  {
    id: 'apple-ipad-pro-13',
    name: 'Apple iPad Pro 13" M4',
    category: 'geraete',
    price: 1099,
    oldPrice: 1199,
    monatlich: '45',
    anschlusshebühr: '29,99',
    description: 'Das Apple iPad Pro 13 mit M4 Chip, Ultra Retina XDR Display und Apple Pencil Pro. Das leistungsstärkste iPad für Profis.',
    features: [
      '13" Ultra Retina XDR OLED Display',
      'Apple M4 Chip',
      '12MP Hauptkamera mit 4K Video',
      'Wi-Fi 6E + 5G Option',
      'Apple Pencil Pro kompatibel',
      'Dünnes und leichtes Design',
    ],
    image: 'https://images.pexels.com/photos/1334597/pexels-photo-1334597.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: iPad Pro 13' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'samsung-galaxy-tab-s10-ultra',
    name: 'Samsung Galaxy Tab S10 Ultra',
    category: 'geraete',
    price: 999,
    oldPrice: 1149,
    monatlich: '40',
    anschlusshebühr: '29,99',
    description: 'Das Samsung Galaxy Tab S10 Ultra mit 14,6 Zoll Display, S-Pen und Snapdragon 8 Gen 3. Das größte und leistungsstärkste Android-Tablet.',
    features: [
      '14,6" Dynamic AMOLED 2X 120Hz Display',
      'Snapdragon 8 Gen 3 Prozessor',
      'S-Pen im Lieferumfang',
      '11200 mAh Akku',
      '5G + Wi-Fi 7',
      'Quad-Lautsprecher von AKG',
    ],
    image: 'https://images.pexels.com/photos/1334597/pexels-photo-1334597.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Galaxy Tab S10 Ultra' },
    ],
    isNew: true,
  },
  {
    id: 'apple-watch-series-10',
    name: 'Apple Watch Series 10',
    category: 'geraete',
    price: 449,
    oldPrice: 499,
    monatlich: '20',
    anschlusshebühr: '19,99',
    description: 'Die Apple Watch Series 10 mit größerem Display, schnellerem Chip und neuen Gesundheitsfunktionen. Die beste Smartwatch für iPhone-Nutzer.',
    features: [
      '46mm/42mm Always-On Retina Display',
      'S10 SiP Chip',
      'ECG, Blut-Sauerstoff & Temperatur-Sensor',
      'Wasserdicht bis 50m',
      'GPS + Cellular Option',
      'watchOS 11',
    ],
    image: 'https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Apple Watch Series 10' },
    ],
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'samsung-galaxy-watch-7',
    name: 'Samsung Galaxy Watch 7',
    category: 'geraete',
    price: 329,
    oldPrice: 379,
    monatlich: '15',
    anschlusshebühr: '19,99',
    description: 'Die Samsung Galaxy Watch 7 mit Wear OS 5, BioActive Sensor und verbesserter KI-Gesundheitsüberwachung.',
    features: [
      '44mm/40mm Super AMOLED Display',
      'Exynos W1000 Chip',
      'BioActive Sensor mit KI',
      'GPS + Cellular Option',
      'IP68 wasserfest',
      'Wear OS 5',
    ],
    image: 'https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Galaxy Watch 7' },
    ],
    isNew: true,
  },
  {
    id: 'apple-airpods-pro-2',
    name: 'Apple AirPods Pro 2 (USB-C)',
    category: 'geraete',
    price: 249,
    oldPrice: 279,
    monatlich: '12',
    anschlusshebühr: '9,99',
    description: 'Apple AirPods Pro 2 mit USB-C, Active Noise Cancellation und Adaptive Audio. Die besten True-Wireless-Kopfhörer für Apple-Nutzer.',
    features: [
      'Active Noise Cancellation',
      'Adaptive Audio & Transparency-Modus',
      'USB-C Ladegehäuse',
      'Bis zu 6 Stunden Akku (mit ANC)',
      'IP54 staub- und wasserfest',
      'Personalized Spatial Audio',
    ],
    image: 'https://images.pexels.com/photos/3780681/pexels-photo-3780681.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: AirPods Pro 2' },
    ],
    isFeatured: true,
  },
  {
    id: 'sony-wh-1000xm5',
    name: 'Sony WH-1000XM5',
    category: 'geraete',
    price: 329,
    oldPrice: 399,
    monatlich: '15',
    anschlusshebühr: '9,99',
    description: 'Sony WH-1000XM5 mit branchenführender Noise Cancellation, 30 Stunden Akku und kristallklarem Klang. Der Testsieger unter den Over-Ear-Kopfhörern.',
    features: [
      'Branchenführende Noise Cancellation',
      '30 Stunden Akkulaufzeit',
      'Multipoint Bluetooth-Verbindung',
      'LDAC Hi-Res Audio',
      'Schnellladen: 3 Min = 3 Stunden',
      'Leichtes Design (250g)',
    ],
    image: 'https://images.pexels.com/photos/3780681/pexels-photo-3780681.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'O2 Deal: Sony WH-1000XM5' },
    ],
  },

  // Mobilfunk
  {
    id: 'vodafone-giga-mobil-m',
    name: 'Vodafone GigaMobil M',
    category: 'mobilfunk',
    price: null,
    oldPrice: null,
    monatlich: '39,99',
    anschlusshebühr: '39,99',
    description: 'Vodafone GigaMobil M mit 20GB Datenvolumen, 5G und Allnet-Flat. Der beliebteste Vodafone-Tarif.',
    features: [
      '20 GB Datenvolumen mit 5G',
      'Allnet-Flat in alle dt. Netze',
      'SMS-Flatrate',
      'EU-Roaming inklusive',
      'Vodafone D2-Netz',
      '24 Monate Laufzeit',
    ],
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'vodafone', url: 'https://ndirect.ppro.de/click/iy4r', dealText: 'Jetzt Vodafone GigaMobil M abschließen' },
    ],
    isFeatured: true,
  },
  {
    id: 'o2-o2-free-s',
    name: 'O2 O2 Free S',
    category: 'mobilfunk',
    price: null,
    oldPrice: null,
    monatlich: '19,99',
    anschlusshebühr: '29,99',
    description: 'O2 Free S mit 5GB Datenvolumen im O2-Netz. Der günstige Einsteigertarif mit Allnet-Flat.',
    features: [
      '5 GB Datenvolumen (LTE/5G)',
      'Allnet-Flat in alle dt. Netze',
      'SMS-Flatrate',
      'EU-Roaming inklusive',
      'O2/Telefónica Netz',
      '24 Monate Laufzeit',
    ],
    image: 'https://images.pexels.com/photos/4195327/pexels-photo-4195327.jpeg?auto=compress&cs=tinysrgb&w=800',
    affiliateLinks: [
      { provider: 'o2', url: 'https://www.communicationads.net/tc.php?t=18676C16024222T', dealText: 'Jetzt O2 Free S abschließen' },
    ],
  },
];

export function getProductById(id: string): Product | undefined {
  return PRODUCTS.find(product => product.id === id);
}

export function getProductsByCategory(category: string): Product[] {
  return PRODUCTS.filter(product => product.category === category);
}

export function getFeaturedProducts(limit: number = 6): Product[] {
  return PRODUCTS.filter(product => product.isFeatured).slice(0, limit);
}

export function getNewProducts(limit: number = 4): Product[] {
  return PRODUCTS.filter(product => product.isNew).slice(0, limit);
}
